import React, { useEffect } from 'react';
import LinedesignBanner from './LinedesignBanner';
import LinedesignCards from './LinedesignCards';
import DigitalManufactuirngCards from './DigitalManufactuirngCards';
const Caselinedesignpage = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []); // Empty dependency array ensures it only runs once when the component mounts
    // Scroll to the top of the page when the component mounts

    return (
        <div style={{ backgroundColor: '#fff' }}>
            <LinedesignBanner />
            {/* <CasedigitalmarketingBanner /> */}
            {/* <DigitalManufactuirngCards /> */}
             <LinedesignCards />

        </div>
    );
};

export default Caselinedesignpage;
